import React, { Component } from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom'
import Loadable from 'react-loadable'
// Components
import ScrollToTop from './components/ScrollToTop'
// Contentful
import { initClient } from './services/contentfulClient'
import * as config from './services/config'

// init
window.Intercom('boot', {
  app_id: 'tvvput5m'
});

const Loading = (props) => {
  if (props.error) {
    return <div>Error!</div>;
  } else if (props.pastDelay) {
    return <div></div>
  } else {
    return null;
  }
}

// Pages
const Home = Loadable({
  loader: () => import('./pages/Home'),
  loading: Loading
})

const Projects = Loadable({
  loader: () => import('./pages/Projects'),
  loading: Loading
})

const Careers = Loadable({
  loader: () => import('./pages/Careers'),
  loading: Loading
})

const ContactUs = Loadable({
  loader: () => import('./pages/ContactUs'),
  loading: Loading
})

const Media = Loadable({
  loader: () => import('./pages/Media'),
  loading: Loading
})

class App extends Component {
  componentWillMount () {
    const { spaceId, deliveryAccessToken } = config
    initClient(spaceId, deliveryAccessToken)
      .then(() => console.log(`Contentful Client Initialised`))
      .catch(err => console.log(err))
  }

  render() {
    return (
      <Router onUpdate={() => {
        //
        window.Intercom('update');
      }}>
        <ScrollToTop>
          <Route exact path="/" component={Home}/>
          <Route exact path="/index.html" component={Home}/>
          <Route path="/projects" component={Projects}/>
          <Route path="/careers" component={Careers}/>
          <Route path="/contact" component={ContactUs}/>
          <Route path="/resources" component={Media}/>
        </ScrollToTop>
      </Router>
    )
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js